import * as JSONMapper from "json-mapper";
import {JSONMapped, jsonProperty} from "json-mapper-reflect";
import * as moment from "moment";

export class AvdbIssue extends JSONMapped() {
	@jsonProperty()
	name: string;

	@jsonProperty(JSONMapper.timestampFromISO)
	availableAt: moment.Moment;

	@jsonProperty(JSONMapper.timestampFromISO)
	effectiveAt: moment.Moment;

	@jsonProperty(JSONMapper.timestampFromISO)
	invalidAt: moment.Moment;

	@jsonProperty()
	versionNumber: string;

	constructor(data?: Partial<AvdbIssue>) {
		super();
		Object.assign(this, data);
	}

	get isExpired() {
		return this.invalidAt != null && this.invalidAt.isBefore(moment());
	}

	get isEffective() {
		return this.effectiveAt != null && this.effectiveAt.isBefore(moment()) && !this.isExpired;
	}

	get isFutureIssue() {
		return !this.isEffective && !this.isExpired;
	}
}
